module.exports = "./img/7aae9324cd5f54db97376904070b7b74.jpg";